import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSurveyComponent } from './user-survey.component';
import {CardOverlayModule} from "@pages/user/partials/card-overlay/card-overlay.module";


@NgModule({
  declarations: [UserSurveyComponent],
  imports: [
    CommonModule,
    CardOverlayModule
  ],
  exports: [UserSurveyComponent]
})
export class UserSurveyModule { }
